import React from 'react';
import { Footer } from 'antd/lib/layout/layout';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
// import Container from 'components/container';
import { baseStyle } from 'components/Layout/styles';
import moment from 'utils/datetime';
import { Col, Row, Typography } from 'antd';

const Section = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledFooter = styled(Footer)`
  ${baseStyle};
  background-color: #20252b;
  height: 49px;
  padding: 5px 50px !important;
  @media screen and (max-width: 992px) {
    height: 100%;
  }
`;

const StyledLink = styled(Typography.Link)`
  margin: 0 1rem;
  color: var(--neutral-6) !important;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const CopyrightText = styled.div`
  color: var(--text-color-secondary);
`;

const BlackFooter = (): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  return (
    <StyledFooter>
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24 }, 16]}
        justify="space-between"
        style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '1384px' }}
      >
        <Col style={{ padding: 0 }}>
          <Section>
            {/* <StyledLink
              to="privacy-policy"
              data-testid="footer-policy"
              style={{ fontSize: '15px' }}
            >
              {t('blackFooter.privacyPolicy')}
            </StyledLink> */}
            <StyledLink
              href={
                isEnglish
                  ? 'https://www.generali.com.hk/EN_US/privacy_security_cookies'
                  : 'https://www.generali.com.hk/ZH_HK/privacy_security_cookies'
              }
              data-testid="footer-policy"
              style={{ fontSize: '15px' }}
            >
              {t('blackFooter.privacyPolicy')}
            </StyledLink>
            {/* <StyledLink to="terms-and-conditions" data-testid="footer-tnc" style={{ fontSize: '15px' }}>
              {t('blackFooter.tnc')}
            </StyledLink> */}
            <StyledLink
              href={
                isEnglish
                  ? 'https://www.generali.com.hk/EN_US/legal_information'
                  : 'https://www.generali.com.hk/ZH_HK/legal_information'
              }
              data-testid="footer-tnc"
              style={{ fontSize: '15px' }}
            >
              {t('blackFooter.tnc')}
            </StyledLink>
          </Section>
        </Col>
        <Col style={{ padding: 0 }}>
          <Section>
            <CopyrightText data-testid="footer-copyright" style={{ fontSize: '15px' }}>
              {t('blackFooter.copyrightnew', { year: moment(new Date()).year() })}
            </CopyrightText>
          </Section>
        </Col>
      </Row>
    </StyledFooter>
  );
};

export default BlackFooter;
